import { render, staticRenderFns } from "./BlockAccountCreateDialog.vue?vue&type=template&id=11a785c9"
import script from "./BlockAccountCreateDialog.vue?vue&type=script&lang=js"
export * from "./BlockAccountCreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports